<template>
  <div class="login">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-8 col-md-6 col-lg-4 mx-auto">
          <div class="login__logo">
            <img
              src="../assets/dm-logo.png"
              class="img-fluid mb-3"
              width="400"
            >
            <p>Customer Insight Data Intelligence</p>
          </div>
          <div class="card mb-5">
            <div class="card-body p-lg-4 p-xl-5">

              <form @submit.prevent="onSubmit(email, password)">

                <div class="form-group">
                  <label for="login-email">Email address</label>
                  <input
                    class="form-control"
                    id="login-email"
                    type="email"
                    v-model="email"
                  />
                </div>
                <div class="form-group">
                  <label for="login-password">Password</label>
                  <input
                    class="form-control"
                    id="login-password"
                    type="password"
                    v-model="password"
                  />    
                </div>
                <div class="form-group form-check">
                  <input type="checkbox" class="form-check-input" id="remember">
                  <label class="form-check-label" for="remember">Remember</label>
                </div>
                <div class="text-right">
                  <button class="btn btn-primary" type="submit">Connect</button>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {
  LOGIN,
  FETCH_USER,
  FETCH_TAXONOMIES,
  FETCH_TARGETS
} from "@/store/actions.type";

import {
  SET_FILTERS
} from "@/store/mutations.type";

export default {
  name: "AppLogin",
  data() {
    return {
      email: null,
      password: null
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "section"]),
  },
  methods: {
    onSubmit(email, password) {

      let validationError = false;

      if(!email || !password) {
        Swal.fire(
          'Error!',
          'Missing email or password',
          'error'
        );
        validationError = true;
      }

      if(!validationError) {

        let loginData = new FormData();
        loginData.set('email', email);
        loginData.set('password', password);

        this.$store.dispatch(LOGIN, loginData).then(() => {

          let user = this.$store.dispatch(FETCH_USER);
          let taxonomies = this.$store.dispatch(FETCH_TAXONOMIES);
          let targets = this.$store.dispatch(FETCH_TARGETS);

          let defaultFilters = {
            filters: {
              tag: null,
              update: null,
              language: null,
              pertinency: null
            }
          }
          this.$store.commit(SET_FILTERS, defaultFilters);

          return Promise.all([user, taxonomies, targets])
            .then(() => {
              this.$router.push({ name: "Dashboard" });
            });

          // this.$store
          //  .dispatch(FETCH_USER)
          //  .then(() => this.$router.push({ name: "Dashboard" }));
        });

      }
  
    }
  },
  mounted() {
    if (this.isAuthenticated) {
      if(this.section != 'monitors') {
        this.$router.push({ name: "Dashboard" });
        return;
      } else {
        this.$router.push({ name: "MonitorsDashboard" });
        return;
      }
    }
  }
};
</script>